<!-- requests/unassigned -->
<template>
  <RequestsTableRedesigned
    :api-url-props="'/v2/requests?unassigned=true'"
    title="Unassigned Requests"
  />
</template>

<script>

import RequestsTableRedesigned from './RequestsTableRedesigned.vue'

export default {
  components: {
    RequestsTableRedesigned,
  },

}
</script>
